import PropTypes from "prop-types"
import React from "react"

/**
 * A href element that will not render an anchor if noHref is passed for SEO purposes
 */
export const PageItem = React.forwardRef(({ noAnchorWhenHrefEmpty = true, href, className, ...props }, ref) => {
  if (!href && noAnchorWhenHrefEmpty) {
    return <span {...props} className={className} ref={ref} />
  }

  return <a {...props} className={className} href={href} ref={ref} />
})

PageItem.displayName = "PageItem"
PageItem.propTypes = {
  /**
   * If false will always render an anchor
   */
  noAnchorWhenHrefEmpty: PropTypes.bool,
}
